// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zetachainAthensTestnet as _zetachainAthensTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zetachainAthensTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 7001
 * Chain Name: ZetaChain Athens Testnet
 * Default Block Explorer: https://athens.explorer.zetachain.com
 * Default RPC URL: https://zetachain-athens-evm.blockpi.network/v1/rpc/public
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zetachainAthensTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zetachainAthensTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zetachainAthensTestnet = createCommon({
	..._zetachainAthensTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
